package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.component.dashboard_reports.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.overlay.PopupPlacement
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStatistic
import org.hs_soft.runmynesto.domain.util.IdUtils
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomTooltip
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun DashboardReportItem(
    windowSizeMode: WindowSizeModeEnum,
    model: ShopStatistic,
    currencyType: String,
    name: String?,
    cashTotal: Double,
    eftTotal: Double,
    creditTotal: Double,
    tipsTotal: Double,
    cancelledTotal: Double,
    revenuePerOperation: Double,
    onItemClick: () -> Unit,
)
{

    Column(
        modifier = Modifier
            .cursor(Cursor.Pointer)
            .margin(
                right = if (windowSizeMode== WindowSizeModeEnum.PHONE) 0.px
                        else Dimen.extraLargePadding,
                bottom = Dimen.mediumPadding,
                top = Dimen.mediumPadding,
            )
            .rippleEffect {
                onItemClick()
            }
            .width(
                when(windowSizeMode){
                    WindowSizeModeEnum.Desktop->Dimen.dashboardReportItemWidth
                    WindowSizeModeEnum.TABLET->Dimen.dashboardReportItemTabletPhoneWidth
                    WindowSizeModeEnum.PHONE->Dimen.dashboardReportItemTabletPhoneWidth
                }
            )
            .thenIf(
                windowSizeMode== WindowSizeModeEnum.PHONE,
                Modifier
                    .fillMaxWidth()
                    .height(Dimen.dashboardReportItemMobileHeight)
            )
            .thenIf(
                windowSizeMode!= WindowSizeModeEnum.PHONE,
                Modifier
                    .height(Dimen.dashboardReportItemHeight)
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb,
            ),
    )
    {
        TopHeader(
            name=name?:"",
        )

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(Dimen.largePadding)
        )
        {
            GeneralInfo(
                currencyType=currencyType,
                revenuePercentage=model.statData?.revenueChangePct,
                totalRevenue=model.statData?.totalRevenue,
            )

            if (windowSizeMode== WindowSizeModeEnum.PHONE)
            {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically,
                ){
                    InfoDetail(
                        currencyType=currencyType,
                        cashTotal=cashTotal,
                        eftTotal=eftTotal,
                        creditTotal=creditTotal,
                        tipsTotal=tipsTotal,
                        cancelledTotal=cancelledTotal,
                        revenuePerOperation=revenuePerOperation,
                    )
                }
            }else{
                Column(){
                    InfoDetail(
                        currencyType=currencyType,
                        cashTotal=cashTotal,
                        eftTotal=eftTotal,
                        creditTotal=creditTotal,
                        tipsTotal=tipsTotal,
                        cancelledTotal=cancelledTotal,
                        revenuePerOperation=revenuePerOperation,
                    )
                }
            }



        }


    }


}

@Composable
private fun InfoDetail(
    currencyType: String,
    cashTotal: Double,
    eftTotal: Double,
    creditTotal: Double,
    tipsTotal: Double,
    cancelledTotal: Double,
    revenuePerOperation: Double,
) {
    Column()
    {
        if (cashTotal!=0.0){
            DashboardReportInfo(
                title = Strings.current().cash,
                value = "${formatToTwoDecimals(value=cashTotal)} $currencyType",
                color = Theme.SuccessLight.hex,
                icon = Res.PathIcon.cash
            )
        }

        if (eftTotal!=0.0){
            DashboardReportInfo(
                title = Strings.current().eft,
                value = "${formatToTwoDecimals(value=eftTotal,)} $currencyType",
                color = Theme.PrimaryLight.hex,
                icon = Res.PathIcon.eft,
            )
        }

        if (creditTotal!=0.0){
            DashboardReportInfo(
                title = Strings.current().credit,
                value = "${formatToTwoDecimals(value=creditTotal)} $currencyType",
                color = Theme.WarningLight.hex,
                icon = Res.PathIcon.credit,
            )
        }

    }

    Column() {
        if (tipsTotal!=0.0){
            DashboardReportInfo(
                title = Strings.current().tips,
                value = "${formatToTwoDecimals(value=tipsTotal)} $currencyType",
                color = Theme.SecondaryLight.hex,
                icon = Res.PathIcon.tips,
            )
        }

        if (cancelledTotal!=0.0){
            DashboardReportInfo(
                title = Strings.current().cancelled,
                value = "${formatToTwoDecimals(value=cancelledTotal)} $currencyType",
                color = Theme.ErrorLight.hex,
                icon = Res.PathIcon.cancel,
            )
        }

        if (revenuePerOperation!=0.0){
            DashboardReportInfo(
                title = Strings.current().revenueGuest,
                value = "${formatToTwoDecimals(value=revenuePerOperation,)} $currencyType",
                color = Theme.PrimaryInfoLight.hex,
                icon = Res.PathIcon.revenueGuest,
            )
        }

    }




}


@Composable
private fun GeneralInfo(
    currencyType: String,
    revenuePercentage: Double?,
    totalRevenue: Double?,
) {

    val showTooltip= remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        delay(100)
        showTooltip.value = true
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .borderRadius(Dimen.lowBorderRadius)
            .backgroundColor(Theme.SuccessAlertFill.rgb)
            .height(Dimen.dashboardItemGeneralInfoHeight),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    )
    {
        if (totalRevenue!=null){
            SpanText(
                text = Strings.current().totalRevenue ,
                modifier = Modifier
                    .color(Theme.SuccessLight.rgb)
                    .fontSize(FontSizes.semiMediumFontSize)
                    .fontFamily(FontFamily.Jakarta)
            )

            SpanText(
                text = formatToTwoDecimals(totalRevenue)+" "+currencyType,
                modifier = Modifier
                    .color(
                        if (totalRevenue >= 0.0)
                            Theme.SuccessLight.rgb
                        else Theme.ErrorLight.rgb
                    )
                    .fontWeight(FontWeight.Bold)
                    .fontSize(FontSizes.largeFontSize)
                    .fontFamily(FontFamily.Jakarta)
            )

        }

        if (totalRevenue != null
            && revenuePercentage!=0.0
            && revenuePercentage!=null
        ) {
            Box(
                modifier = Modifier
                    .id(IdUtils.dashboardItemId)
            )
            {
                Row(
                    modifier = Modifier
                        .margin(top=Dimen.smallPadding)
                        .padding(leftRight = Dimen.smallPadding)
                        .width(Dimen.dashboardItemPercentageWidth)
                        .height(Dimen.dashboardItemPercentageHeight)
                        .borderRadius(Dimen.dashboardItemPercentageBorder)
                        .backgroundColor(
                            if (totalRevenue>=0.0)Theme.Green100.rgb
                            else Theme.ErrorStateFocusVisible.rgb
                        ),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center,
                )
                {
                    VectorIcon(
                        modifier = Modifier,
                        pathData =Res.PathIcon.increase,
                        color = if (totalRevenue>=0.0)Theme.SuccessMain.hex
                        else Theme.ErrorLight.hex,
                        width = Dimen.extraSmallIcon,
                        height = Dimen.extraSmallIcon,
                    )

                    Spacer()

                    SpanText(
                        text ="0.0",
//                    if (revenuePercentage==0.0) "0.0%"
//                    else if(revenuePercentage > 0.0) "+$revenuePercentage%"
//                    else "-$revenuePercentage%",
                        modifier = Modifier
                            .fontFamily(FontFamily.Jakarta)
                            .fontWeight(FontWeight.Medium)
                            .fontSize(FontSizes.normalFontSize)
                            .color(Theme.SuccessMain.rgb)

                    )

                }

                if (showTooltip.value){
                    CustomTooltip(
                        tooltipId = IdUtils.dashboardItemId,
                        placement = PopupPlacement.Top,
                        itemTitle =  Strings.current().comparedToPreviousWeek,
                    )

                }


            }

        }



    }



}


@Composable
private fun TopHeader(
    name: String,
)
{
    Column(
        modifier =Modifier
            .backgroundColor(Theme.ActionHover.rgb)
            .fillMaxWidth()
            .overflow(Overflow.Hidden)
            .padding(
                leftRight = Dimen.largePadding,
            )
            .height(Dimen.dashboardReportItemHeaderHeight),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.Start,
    )
    {
        SpanText(
            text=name,
            modifier = Modifier
                .fillMaxWidth()
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.largeFontSize)
                .color(Theme.TextSecondary.rgb)
                .fontWeight(FontWeight.SemiBold)
                .overflowText()
        )



    }
}

@Composable
fun DashboardReportInfo(
    modifier: Modifier=Modifier,
    title: String,
    value: String,
    color: String,
    marginTop:CSSSizeValue<CSSUnit.px> = Dimen.normalPadding,
    icon: String,
    hasBorder:Boolean=false,

)
{
    Row(
        modifier = modifier
            .padding(
                leftRight = Dimen.largePadding,
            )
            .margin(
                top=marginTop
            )
            .thenIf(
                hasBorder,
                modifier.borderSetting()
            )
            .width(Dimen.dashboardReportItemInfoWidth)
            .height(Dimen.dashboardReportItemInfoHeight),
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        Box(Modifier.size(Dimen.mediumIconSize.px)){
            VectorIcon(
                modifier = Modifier,
                pathData = icon,
                color = color,
                height = Dimen.mediumIconSize,
                width = Dimen.mediumIconSize,
            )
        }


        Column(
            modifier = Modifier
                .fillMaxWidth()
                .height(Dimen.dashboardReportItemInfoInnerHeight)
                .margin(left=Dimen.mediumPadding,)
        )
        {
            SpanText(
                text= title,
                modifier = Modifier
                    .overflowText()
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.semiMediumFontSize)
                    .color(Theme.TextSecondary.rgb)
            )

            SpanText(
                text= value,
                modifier = Modifier
                    .overflowText()
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.largeFontSize)
                    .color(Color(color))
                    .fontWeight(FontWeight.SemiBold)
            )
        }


    }


}